import ApiResponse from '@core/types/apiResponse';
import { ErrorResponse } from '@core/types/errorResponse';
import axios, { AxiosRequestConfig, Method } from 'axios';
import { sendRequest as sendRequestUtils } from '@infrastructure/api/utils/requestUtils';

// Separate API client for auth endpoints (no interceptors)
export const authApiClient = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`,
  withCredentials: true,
});



export async function sendRequest<TReq, TRes>(
    method: Method,
    url: string,
    data?: TReq,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<TRes, ErrorResponse>> {
    return sendRequestUtils(authApiClient, method, url, data, config);
  }         